export default {"src":"/_next/static/media/mybets.0608fe7f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};